// extracted by mini-css-extract-plugin
export default {"starting":"StartingPageContent_starting__kKeBF"};